var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CECECE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,4.6H5.9c-2.6,0-4.8,2.1-4.8,4.8v12.5c0,2.6,2.1,4.8,4.8,4.8h18.2c2.6,0,4.8-2.1,4.8-4.8V9.4   C28.9,6.8,26.8,4.6,24.1,4.6z M2.3,9.4c0-1.9,1.7-3.5,3.6-3.5h18.2c1.9,0,3.5,1.6,3.5,3.5v11.7l0,0c-2.7-1.5-5.4-3-8.1-4.4   c-0.2-0.1-0.3-0.1-0.4,0.1c-1.5,1.4-2.9,2.7-4.4,4.1c-2.1-1.4-4.1-2.9-6.2-4.3c-2.1,1.8-4.1,3.6-6.2,5.4c0,0,0,0,0-0.1L2.3,9.4   L2.3,9.4z M2.8,23.4c1.9-1.6,3.8-3.3,5.7-4.9c0.1-0.1,0.1-0.1,0.2-0.2c1.7,1.2,3.3,2.3,5,3.5c-0.9,0.9-1.9,1.7-2.8,2.6   c-0.3,0.3-0.7,0.6-1,1h-4C4.5,25.4,3.3,24.5,2.8,23.4z M24.1,25.4H11.9c2.5-2.3,5-4.7,7.5-7c0.1-0.1,0.2-0.1,0.4,0   c2.6,1.4,5.2,2.9,7.8,4.3C27.2,24.2,25.8,25.4,24.1,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,16.4c2.2,0,4.2-1.8,4.2-4.2C18,9.9,16.1,8,13.8,8s-4.2,1.9-4.2,4.1C9.6,14.6,11.6,16.5,13.8,16.4z    M13.8,9.4c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9C11,10.7,12.3,9.4,13.8,9.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.10bd652cb0b75307971cda7dbe72d697.svg";
export { ForwardRef as ReactComponent };